export default __webpack_public_path__ + "ad5a95b1ea64958403c9a3316ba84fc4.svg";